export const errorsType = {
  notFound: 404,
  forbidden: 403
}
